(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-amb-builder]').forEach(builder => {
    if (builder.dataset.ready) return;
    builder.dataset.ready = 'true';
    const offers = [...builder.querySelectorAll('[data-amb-offer]')];
    const product = builder.closest('[data-amp-product]');
    const panelFor = offer => document.getElementById(offer.querySelector('.amb-choice input').getAttribute('aria-controls'));
    const publish = offer => {
      const field = panelFor(offer).querySelector('[data-amb-variant]');
      const option = field?.selectedOptions?.[0] || field;
      const available = option?.dataset.available === 'true';
      const price = option?.dataset.price || '';
      const button = panelFor(offer).querySelector('[data-amb-add]');
      button.disabled = !available;
      button.replaceChildren(document.createTextNode(available ? button.dataset.add + ' · ' + price : button.dataset.sold));
      if (product && offer.classList.contains('is-selected')) {
        const salePrice=Number(option.dataset.priceCents||0),comparePrice=Number(option.dataset.compareCents||0),isSale=comparePrice>salePrice;
        const compare=product.querySelector('[data-am-sale-compare]'),percent=product.querySelector('[data-am-sale-percent]');
        if(compare){compare.hidden=!isSale;compare.querySelector('[data-am-compare-value]').textContent=option.dataset.compare||'';}
        if(percent){percent.hidden=!isSale;percent.textContent=isSale?'−'+Math.floor((comparePrice-salePrice)*100/comparePrice)+' %':'';}

        product.querySelectorAll('[data-amp-price],[data-amp-sticky-price]').forEach(el => el.textContent = price);
        const sticky = product.querySelector('[data-amp-sticky-add]');
        if (sticky) sticky.disabled = !available;
        const title = product.querySelector('.amp-sticky-info > strong');
        if (title) title.textContent = offer.querySelector('.amb-choice-title strong').textContent;
      }
    };
    const select = chosen => {
      offers.forEach(offer => {
        const active = offer === chosen;
        offer.classList.toggle('is-selected', active);
        panelFor(offer).hidden = !active;
        offer.querySelector('.amb-choice input').checked = active;
      });
      builder.querySelectorAll('[data-amb-extra]').forEach(el => el.hidden = Number(el.dataset.ambExtra) > Number(chosen.dataset.ambOffer));
      builder.dataset.tier = chosen.dataset.ambOffer;
      publish(chosen);
    };
    offers.forEach(offer => {
      offer.querySelector('.amb-choice input').addEventListener('change', () => select(offer));
      const variantField = panelFor(offer).querySelector('[data-amb-variant]');
      const json = panelFor(offer).querySelector('[data-amb-variants]');
      if (json) {
        const variants = JSON.parse(json.textContent);
        const controls = panelFor(offer).querySelector('[data-amb-options]');
        const groups = [...controls.querySelectorAll('[data-amb-option]')];
        controls.hidden = false;
        panelFor(offer).querySelector('[data-amb-fallback]').hidden = true;
        const sync = () => {
          const values = groups.map(g => g.querySelector('input:checked')?.value);
          const variant = variants.find(v => v.options.every((v, i) => v === values[i]));
          if (!variant) { panelFor(offer).querySelector('[data-amb-add]').disabled = true; return; }
          variantField.value = String(variant.id);
          publish(offer);
        };
        controls.addEventListener('change', sync);
        sync();
      }
      variantField?.addEventListener('change', () => publish(offer));
    });
    if (offers.length) select(offers[0]);
    if (product) {
      const sticky = product.querySelector('[data-amp-sticky]');
      const button = product.querySelector('[data-amp-sticky-add]');
      button?.addEventListener('click', () => {
        const form = panelFor(builder.querySelector('.is-selected')).querySelector('form');
        const submit = form?.querySelector('[type=submit]');
        if (submit && !submit.disabled) form.requestSubmit(submit);
      });
      if (sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0; });
        observer.observe(builder);
        document.addEventListener('shopify:section:unload', e => { if(e.target.contains(builder)) observer.disconnect(); });
      }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

